   <template>
   
    <!--公用弹框-->
    <div class="popbox" id="popbox-tishi3" style="display:block">
      <div class="popbox-inner">
          <a class="popbox-close" href="javascript:void(0)" @click="ensure()">&times;</a>
          <div class="popbox-body">
            <p>{{content}}</p>
          </div>
      </div>
    </div>
    <!--//公用弹框-->
    
</template>

<script>
import $ from "jquery";

export default {
  data() {
    return {
      content: null
    };
  },
  methods: {
    ensure() {
      $("#popbox-tishi3").remove();
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/MessageBox/Message.vue